import { AfterContentInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-dedicate-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./dedicate-create.component.scss']
})
export class DedicateCreateComponent extends UserCreateComponent implements OnInit, AfterContentInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'dedicate';
  }

  ngAfterContentInit() {
    if (this.isEdit) {
      this.fields = this.fields.filter(c => !['bandwidth', 'invoice_period', 'price_per_meg'].includes(c.name));
    } else {
      this.service.apiCall('api/user/getLastDedicateName', {}).subscribe((result: any) => {
        this.formData.username = result.name;
      });
    }
  }

}
